import React from 'react';
import classnames from 'classnames/bind';
import { string } from 'prop-types';

import Icon from 'foundations/Icons/Icon';

import styles from './CardTypeA.css';

const getFlagImage = flagName => require(`assets/images/flags/${flagName}.png`);
const cx = classnames.bind(styles);

const CardTypeA = ({ title, label, flag, arrow, rate }) => {
  const flagImage = getFlagImage(flag);
  const icon = {
    type: 'other',
    responsive: true,
    icon: arrow === 'up' ? 'arrow-up-10' : 'arrow-down-10',
    customClasses: cx('icon', { 'upColor': arrow === 'up', 'downColor': arrow === 'down' })
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardHead}>
        <p className={styles.title}>{title}</p>
        <p className={styles.label}>{label}</p>
      </div>

      <div
        className={styles.flag}
        style={{ backgroundImage: `url(${flagImage})` }} />

      <p className={cx('rates', { 'upColor': arrow === 'up', 'downColor': arrow === 'down' })}>
        {rate}
      </p>
      <Icon {...icon} />
    </div>
  );
};

CardTypeA.propTypes = {
  title: string.isRequired,
  label: string.isRequired,
  flag: string.isRequired,
  arrow: string.isRequired,
  rate: string.isRequired
};

CardTypeA.displayName = 'CardTypeA';

export default CardTypeA;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/CardBanner/Cards/CardTypeA/CardTypeA.js